import {
    smoothScrollTo,
} from 'helpers';

(() => {
    window.WebFontConfig = {
        google: {
            families: ['Passion+One:400'],
        },
    };

    const firstScriptTag = document.scripts[0];
    const script = document.createElement('script');

    script.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
    script.async = true;

    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
})();

(() => {
    const internalLinks = document.querySelectorAll('a[href*="#"]');

    [...internalLinks].forEach((internalLink) => {
        internalLink.addEventListener('click', (event) => {
            event.preventDefault();

            const elementId = internalLink.getAttribute('href');
            const element = document.querySelector(elementId);

            smoothScrollTo(element);
        });
    });
})();



// WEBPACK FOOTER //
// ./resources/sitewide.js